import React, { useState } from 'react'
import { makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, IconButton, Button } from '@material-ui/core/';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';
import MUIDataTable from "mui-datatables";
import exportFromJSON from 'export-from-json'
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoffee, faFileExcel, faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'

export const NormalTable = ({ data, docsCol, title, pdf, onclick }) => {

    var columns = [];
    const [isLoading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const noCols = ["Sin información"];
    const noData = [[""]];

    const handleClose = (r) => {
        if (r === 'clickaway') {
            return;
        }
        setOpen(false);
    };


    const DownloadFile = async (Opc, IdFact, IdCia, FechaFactura) => {

        try {
            setLoading(true);
            const { data } = await axios.post('/DownloadInvoiceFile', { IdFact: IdFact, Opc: Opc, IdCia: IdCia, FechaFactura: FechaFactura || '' });
            console.log(data);

            if (data && data.success) {
                const file = new Blob(
                    [_base64ToArrayBuffer(data.data[0].Data)],
                    { type: data.data[0].contentType });
                let url = window.URL.createObjectURL(file);
                if (Opc === 1) {
                    setLoading(false);
                    window.open(url);
                } else {
                    setLoading(false);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = `${data.data[0].IdDoc}`;
                    a.click();
                }
            } else {
                setLoading(false);
                setOpen(true);

            }

        } catch (e) {
            console.log(e);
        }

    }

    if (data.length) {

        const skipCols = ['documentos', 'proveedor'];
        columns = Object.keys(data[0])
            .filter(key => !skipCols.includes(key.toLowerCase()))
            .map((key) => ({
                name: key,
                label: replaceAll(key, '_', ' '),
                options: (key == "IdCia" || key == "Id Compañia" ? { display: false } : null),
            }));

        if (docsCol) {

            columns.push(
                {
                    name: 'keyDoc',
                    label: 'Documentos',
                    options: {
                        customBodyRender: (value, tableMeta, updateValue) => (
                            <>
                                <IconButton id={tableMeta.rowData[0]} aria-label="expand row" size="small" disabled={isLoading} onClick={(e) => {
                                    const rowObj = data[tableMeta.rowIndex] || {};
                                    const fecha = rowObj.Fecha || rowObj.FechaFactura || rowObj.fecha || '';
                                    DownloadFile(0, tableMeta.rowData[0], rowObj['Id Compañia'] || '', fecha);
                                }}>
                                    <DescriptionOutlinedIcon color={(isLoading) ? 'disabled' : 'primary'} fontSize={'large'}></DescriptionOutlinedIcon>
                                </IconButton>

                                <IconButton id={tableMeta.rowData[0]} aria-label="expand row" size="small" disabled={isLoading} onClick={(e) => {
                                    const rowObj = data[tableMeta.rowIndex] || {};
                                    const fecha = rowObj.Fecha || rowObj.FechaFactura || rowObj.fecha || '';
                                    DownloadFile(1, tableMeta.rowData[0], rowObj['Id Compañia'] || '', fecha);
                                }}>
                                    <PictureAsPdfOutlinedIcon color={(isLoading) ? 'disabled' : 'secondary'} fontSize={'large'}></PictureAsPdfOutlinedIcon>
                                </IconButton>
                            </>
                        )
                    }
                }
            );

        }
    };

    return (
        <>
            <MUIDataTable
                title={title}
                data={data.length ? data : noData}
                columns={columns.length ? columns : noCols}
                options={{
                    selectableRows: 'none',
                    /*downloadOptions: {
                        filterOptions: {
                            useDisplayedColumnsOnly: true,
                            useDisplayedRowsOnly: true,
                        }
                    },*/
                    customToolbar: () => {
                        if (pdf) {
                            return (
                                <IconButton aria-label="expand row" size="small" disabled={isLoading} onClick={onclick}>
                                    <PictureAsPdfOutlinedIcon color={(isLoading) ? 'disabled' : 'secondary'} fontSize={'large'}></PictureAsPdfOutlinedIcon>
                                </IconButton>
                            );
                        }

                    }
                }}

            />

            <Snackbar open={open} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                <Alert onClose={handleClose} severity="error">
                    Hubo un problema al consultar la factura.
                </Alert>
            </Snackbar>
        </>
    );
}

export const DynamicTable = ({ data }) => {

    var columns = [];
    var rows = [];

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [isLoading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const classes = useStyles();

    const handleClose = (r) => {
        if (r === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const DownloadFile = async (Opc, IdFact, IdCia) => {
        try {
            setLoading(true);

            const { data } = await axios.post('/DownloadInvoiceFile', { IdFact: IdFact, Opc: Opc, IdCia: IdCia });
            console.log(data);
            if (data && data.success) {
                const file = new Blob(
                    [_base64ToArrayBuffer(data.data[0].Data)],
                    { type: data.data[0].contentType });
                let url = window.URL.createObjectURL(file);
                if (Opc === 1) {
                    setLoading(false);
                    window.open(url);
                } else {
                    setLoading(false);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = `${data.data[0].IdDoc}`;
                    a.click();
                }
            } else {
                setLoading(false);
                setOpen(true);
            }
        } catch (e) {
            console.log(e);
            setLoading(false);
            setOpen(true);
        }
    }

    // VALIDACIÓN: Asegurarse de que data tenga elementos antes de procesar
    if (data && data.length > 0) {
        const { Detalle, ...objKeys } = data[0];
        columns = Object.keys(objKeys).map(function (key) {
            return {
                id: key,
                label: replaceAll(key, '_', ' '),
                minWidth: 170,
            }
        });
        console.log(columns);
        rows = data;
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const RowDetail = (props) => {
    const [open, setOpen] = React.useState(false);
    const { dataCol } = props;
    const { dataRow } = props;
    const { Detalle } = dataRow;

    // VALIDACIÓN COMPLETA: Verificar si hay detalle válido
    const hasDetail = Detalle && 
                     Array.isArray(Detalle) && 
                     Detalle.length > 0 && 
                     Detalle[0] && 
                     typeof Detalle[0] === 'object';

    // Si no hay detalle válido, renderizar fila sin botón de expandir
    if (!hasDetail) {
        return (
            <React.Fragment>
                <TableRow key={dataRow.Número_de_factura} hover role='checkbox' tabIndex={-1}>
                    <TableCell key={'icon' + dataRow.Número_de_factura}>
                        {/* Espacio vacío - sin botón de expandir */}
                    </TableCell>
                    {dataCol.map((column) => {
                        const value = dataRow[column.id];
                        return (
                            <TableCell
                                key={column.id}
                                align={column.align}
                            >
                                {column.format && typeof value === 'number' ? column.format(value) : value}
                            </TableCell>
                        );
                    })}
                    <TableCell key={'iconFile' + dataRow.Número_de_factura}>
                        <IconButton id={dataRow.Número_de_factura} aria-label="expand row" size="small" disabled={isLoading} onClick={(e) => {
                            DownloadFile(0, dataRow.Número_de_factura, dataRow.IdCia);
                        }}>
                            <DescriptionOutlinedIcon color={(isLoading) ? 'disabled' : 'primary'} fontSize={'large'}></DescriptionOutlinedIcon>
                        </IconButton>

                        <IconButton id={dataRow.Número_de_factura} aria-label="expand row" size="small" disabled={isLoading} onClick={(e) => {
                            DownloadFile(1, dataRow.Número_de_factura, dataRow.IdCia);
                        }}>
                            <PictureAsPdfOutlinedIcon color={(isLoading) ? 'disabled' : 'secondary'} fontSize={'large'}></PictureAsPdfOutlinedIcon>
                        </IconButton>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    // MOVER AQUÍ: Solo crear las columnas DESPUÉS de validar y DESPUÉS del return
    const detailDtcolumns = Object.keys(Detalle[0]).map(function (key) {
        return {
            key: key,
            id: key,
            label: replaceAll(key, '_', ' '),
            minWidth: 170,
        }
    });

    return (
        <React.Fragment>
            <TableRow key={dataRow.Número_de_factura} hover role='checkbox' tabIndex={-1}>
                <TableCell key={'icon' + dataRow.Número_de_factura}>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                {dataCol.map((column) => {
                    const value = dataRow[column.id];
                    return (
                        <TableCell
                            key={column.id}
                            align={column.align}
                        >
                            {column.format && typeof value === 'number' ? column.format(value) : value}
                        </TableCell>
                    );
                })}
                <TableCell key={'iconFile' + dataRow.Número_de_factura}>
                    <IconButton id={dataRow.Número_de_factura} aria-label="expand row" size="small" disabled={isLoading} onClick={(e) => {
                        DownloadFile(0, dataRow.Número_de_factura, dataRow.IdCia);
                    }}>
                        <DescriptionOutlinedIcon color={(isLoading) ? 'disabled' : 'primary'} fontSize={'large'}></DescriptionOutlinedIcon>
                    </IconButton>

                    <IconButton id={dataRow.Número_de_factura} aria-label="expand row" size="small" disabled={isLoading} onClick={(e) => {
                        DownloadFile(1, dataRow.Número_de_factura, dataRow.IdCia);
                    }}>
                        <PictureAsPdfOutlinedIcon color={(isLoading) ? 'disabled' : 'secondary'} fontSize={'large'}></PictureAsPdfOutlinedIcon>
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={0}>
                            <Typography variant="h6" gutterBottom component="div">
                                Detalle
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        {detailDtcolumns.map((column) => {
                                            return (
                                                <TableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{ minWidth: column.minWidth }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Detalle.map((dt, index) => {
                                        return (
                                            <TableRow key={`detail-${index}`}>
                                                {detailDtcolumns.map((col) => {
                                                    const value = dt[col.id];
                                                    return (
                                                        <TableCell key={`${col.id}-${index}`} align={dt.align}>
                                                            {value}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}

    return (
        <Paper className={classes.root}>
            <div style={{ textAlign: 'right', paddingRight: '20%', paddingTop: '2%', paddingBottom: '3%' }}>
                <IconButton
                    variant="outlined"
                    color="gray"
                    onClick={() => {
                        const fileName = 'download'
                        const exportType = exportFromJSON.types.csv
                        exportFromJSON({ data, fileName, exportType })
                    }}>
                    <FontAwesomeIcon icon={faCloudDownloadAlt} color="gray" />
                </IconButton>
                <button className='btn' onClick={() => {
                    const fileName = 'download'
                    const exportType = exportFromJSON.types.csv
                    exportFromJSON({ data, fileName, exportType })
                }}
                    style={{ borderRadius: 8, borderColor: 'transparent' }}>
                </button>
            </div>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label='sticky table' exportButton={true}>
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                            <TableCell
                                key={'doc'} style={{ minWidth: 170 }}
                            >
                                Documentos
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return (
                                <RowDetail key={row.Número_de_factura} dataCol={columns} dataRow={row} />
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component='div'
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
            <Snackbar open={open} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                <Alert onClose={handleClose} severity="error">
                    Hubo un problema al consultar la factura.
                </Alert>
            </Snackbar>
        </Paper>
    );
}

function replaceAll(string, search, replace) {
    return string.split(search).join(replace);
}

function _base64ToArrayBuffer(base64) {

    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
    table: {
        minWidth: 650,
    },

});